import { TFunction } from 'i18next'
import z from 'zod'

import { MAX_VAT_EXEMPTION_MENTION_LENGTH } from '../../../constants/maxVatExemptionMentionLength'
import { LegalMentionsSettings } from '../../../types/legalSettings/legalMentionsSettings'

const MAX_MENTION_LENGTH = 250

export const getLegalMentionsSchema = (t: TFunction): z.ZodType<LegalMentionsSettings> => {
  return z.object({
    custom: z.object({
      earlyPaymentDiscount: z
        .string()
        .min(1, {
          message: t(
            'settings.organization.external_invoice.legal_mentions.modal.early_payment_discount.custom_mention.error_message',
          ),
        })
        .max(MAX_MENTION_LENGTH)
        .nullable(),
      latePaymentPenaltyRate: z
        .string()
        .min(1, {
          message: t(
            'settings.organization.external_invoice.legal_mentions.modal.late_payment_penalty_rate.custom_mention.error_message',
          ),
        })
        .max(MAX_MENTION_LENGTH)
        .nullable(),
      vatExemptionScheme: z.string().max(MAX_VAT_EXEMPTION_MENTION_LENGTH).nullable(),
    }),
  })
}
